<template>
  <img
    :src="placeholder"
    :data-src="fixedSize ? $image(media.src, fixedSize) : $image(media.src)"
    :data-srcset="fixedSize ? '' : srcset"
    data-sizes="auto"
    class="vimg lazyload"
    :class="customClass"
    :alt="media.alt || $attrs.alt || 'Image'"
    @lazyloaded="$emit('loaded')" />
</template>

<script>
export default {
  name: 'VImg',

  props: {
    media: {
      type: Object,
      required: true
    },
    fixedSize: {
      type: String,
      required: false
    },
    customClass: {
      type: Object,
      required: false
    }
  },

  computed: {
    srcset() {
      if (this.fixedSize) return null

      let srcset = this.$image(this.media.src, '200x') + ' 100w'

      this.media.width >= 200 ? (srcset += `, ${this.$image(this.media.src, '400x')} 200w`) : ''
      this.media.width >= 400 ? (srcset += `, ${this.$image(this.media.src, '800x')} 400w`) : ''
      this.media.width >= 600 ? (srcset += `, ${this.$image(this.media.src, '1200x')} 600w`) : ''
      this.media.width >= 800 ? (srcset += `, ${this.$image(this.media.src, '1600x')} 800w`) : ''
      this.media.width >= 1000 ? (srcset += `, ${this.$image(this.media.src, '2000x')} 1000w`) : ''
      this.media.width >= 1500 ? (srcset += `, ${this.$image(this.media.src, '3000x')} 1500w`) : ''
      this.media.width >= 2000 ? (srcset += `, ${this.$image(this.media.src, '4000x')} 2000w`) : ''

      return srcset
    },
    placeholder() {
      const w = this.media.width
      const h = this.media.height

      if (!w || !h) return ''
      return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"%3E%3C/svg%3E`
    }
  }
}
</script>

<style scoped>
.vimg {
  background-image: url("data:image/svg+xml,%3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3000 4500'%3E%3Cpath d='M2257 2147v22h43v-44h-43v22zM1957.9 2127.4c-.2.2-.3 54.9-.1 121.5l.2 121.1h42.9l.3-57.8c.3-56.5.4-57.8 2.5-63.5 4.1-10.7 11-18 20-21.3 5.3-1.8 17.9-1.8 23.6.2 6.4 2.2 11.9 8.6 14.1 16.2 1.4 5.1 1.6 13.3 1.6 66v60.2h44.1l-.4-68.8c-.3-62.1-.5-69.3-2.1-74.7-7.3-24.6-23.7-38.1-49.6-40.5-12-1.1-20.7.2-29.8 4.5-8.2 3.9-17 11.6-21 18.5l-2.7 4.5-.3-43.3-.2-43.2h-21.3c-11.8 0-21.6.2-21.8.4zM780.3 2186.1c-15.6 2.6-30 13-36 25.9-1 2.2-2 4-2.3 4-.3 0-.5-5.7-.5-12.7v-12.8l-20.7-.3-20.8-.2v180h43.9l.3-62.3.3-62.2 2.3-5c4.9-10.6 11.2-14.4 23.8-14.5 7 0 8.9.4 13.5 2.8 4.5 2.4 5.9 3.7 8.4 8.7l3 5.9.3 63.3.3 63.3h43.8l.3-60.8c.3-60.5.3-60.7 2.6-66.3 2.4-6.1 7.4-11.8 12.5-14.6 2.4-1.4 5.6-1.8 12.9-1.8 9.2 0 9.8.1 13.5 3 5 4 9 12.3 10.3 21 .5 4 1 31.4 1 63.2v56.3h43v-67.3c0-64.3-.1-67.7-2-75.3-2.7-10.6-6.1-17.3-12.2-24-9.4-10.2-20.2-15.7-34.6-17.3-10.6-1.1-19.1.2-28 4.4-8 3.8-18.5 13-21.8 19-1 1.9-2.1 3.5-2.5 3.5-.3 0-2.3-2.5-4.4-5.6-8.7-13.1-18.7-19.5-33.5-21.4-9.4-1.1-9.4-1.1-16.7.1zM1740.4 2186c-11.2.9-22.5 4.2-31.4 9.2-7.9 4.5-20.7 17.8-25.2 26.3-15.7 29.8-18.1 78.2-5.4 109.5 6.5 16.3 18 29.2 31.7 35.9 10 4.8 18.2 6.9 30.4 7.7 35 2.5 62.5-14 75.1-45 3.4-8.4 6.9-23 5.9-24.7-.4-.5-9.7-.9-22-.9h-21.3l-1.1 5.2c-1.6 7.2-6.7 16.3-11.5 20.4-8.2 7.1-21.7 8.2-31.8 2.7-8.2-4.4-12.7-11.5-16.5-25.3-2.5-9.5-2.5-41.8 0-51 4-14.7 10.7-24 19.8-27.9 6.9-3 18.9-3.1 24.6-.3 7.3 3.8 12.6 11.6 15.3 22.4l1.2 4.8h43.8v-4.3c-.1-17.3-11.5-39.1-26.3-50.3-15.9-12-32.1-16.2-55.3-14.4zM1144 2186.6c-20.1 3.9-37.2 13.5-48.6 27.3-7 8.4-13.7 22-17.1 34.6-2.5 9.4-2.7 11.4-2.7 31.5-.1 19.4.1 22.4 2.2 30.2 5 18.9 11.1 29.9 23.2 42 7.5 7.4 10.1 9.3 19.1 13.6 15.2 7.3 21.4 8.7 39.4 8.6 13.3-.1 16-.4 24-2.8 14.8-4.5 23.7-9.7 34-20.1 13.3-13.2 20.4-28 24.1-49.6 2.5-14.9 1.6-39.7-2-53.3-7.9-30.4-27.6-51.5-55.8-59.7-5.7-1.7-10.6-2.2-22.3-2.4-8.2-.2-16.1-.1-17.5.1zm31.2 42.1c10.2 4.6 18.2 16.3 21.4 31.4 2.2 10.1 2.1 31-.1 40.9-3.9 17.2-12.5 28.1-25.2 32-10.2 3.1-22.1 2.3-30.9-2.3-8.1-4.2-15.1-14.5-18.5-27.4-3-11.2-3.1-34.5-.1-45.5 4.6-17 12.2-26.4 24.5-30.4 6.5-2.1 23-1.3 28.9 1.3zM1438 2187.4c-18.3 4.1-34.4 13.7-45.3 27.1-6.3 7.8-14 23.8-16.7 34.6-4.4 18.1-4.6 42.7-.4 60.6 9.7 41.8 43.1 67.2 85.4 65 40.7-2.2 68.9-26.8 77.7-67.7 1.4-6.6 1.8-12.7 1.8-27.5-.1-20.5-1.3-27.8-7-43-9.4-25-31.1-43.5-57.7-48.9-9.1-1.9-29.7-2-37.8-.2zm35.5 41.6c15.1 7.3 22.5 24.4 22.5 51.7 0 15.4-1.7 24.3-6.5 34-6.9 14.1-16.7 19.8-33.5 19.8-8.1 0-10.3-.4-15.1-2.7-10.6-4.9-17.4-14.3-21.6-29.8-2.4-9-2.4-33.7.1-43.5 4.2-17 12.2-27 24.9-31.1 2.7-.9 7.7-1.3 14.2-1.1 8.1.3 10.9.8 15 2.7zM2257 2280v90h43v-180h-43v90z'/%3E%3C/svg%3E");
  background-color: var(--offwhite);
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
}

.lazyloaded:not(.remove-transition) {
  transition: background-color 0.275s;
  background-color: transparent;
  background-image: none;
}
</style>
